export let CodeVerificationErrorOption;
(function (CodeVerificationErrorOption) {
  CodeVerificationErrorOption["ExpiredOrInvalidCode"] = "ExpiredOrInvalidCode";
})(CodeVerificationErrorOption || (CodeVerificationErrorOption = {}));